import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/categories';

export default function ArtigoNavbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (mobileOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [mobileOpen]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70 shadow-sm'
          : 'bg-background-50/80 backdrop-blur-sm'
      }`}
    >
      <div className="w-full px-4 md:px-10">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-3 group flex-shrink-0">
            <span className="font-heading text-lg md:text-xl font-bold text-foreground-900 tracking-tight whitespace-nowrap">
              CSSBuy<span className="text-primary-500">Spreadsheet</span>
            </span>
          </Link>

          {/* Desktop nav */}
          <div className="hidden md:flex items-center gap-3 md:gap-4">
            <Link
              to="/"
              className="inline-flex items-center gap-1.5 text-sm font-semibold text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap px-3 py-1.5 rounded-lg hover:bg-background-100"
            >
              <i className="ri-home-line"></i>
              Início
            </Link>
            <Link
              to="/artigo-cssbuyspreadsheet-guia-completo-2026"
              className="inline-flex items-center gap-1.5 text-sm font-semibold text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap px-3 py-1.5 rounded-lg hover:bg-background-100"
            >
              <i className="ri-book-open-line"></i>
              Guia de Compras
            </Link>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
            >
              Buy It Now
              <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>

          {/* Mobile hamburger */}
          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 bg-background-100 hover:bg-background-200 transition-colors"
            onClick={() => setMobileOpen((prev) => !prev)}
            aria-label={mobileOpen ? 'Fechar menu' : 'Abrir menu'}
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-4 flex flex-col gap-1 max-h-[80vh] overflow-y-auto shadow-lg">
          <Link
            to="/"
            onClick={() => setMobileOpen(false)}
            className="px-4 py-3 text-sm font-semibold text-foreground-700 rounded-lg hover:bg-background-100 transition-colors flex items-center gap-2"
          >
            <i className="ri-home-line text-primary-500"></i>
            Início
          </Link>
          <Link
            to="/artigo-cssbuyspreadsheet-guia-completo-2026"
            onClick={() => setMobileOpen(false)}
            className="px-4 py-3 text-sm font-semibold text-foreground-700 rounded-lg hover:bg-background-100 transition-colors flex items-center gap-2"
          >
            <i className="ri-book-open-line text-primary-500"></i>
            Guia de Compras
          </Link>
          <button
            onClick={() => { setMobileOpen(false); navigate('/'); setTimeout(() => document.getElementById('categorias')?.scrollIntoView({ behavior: 'smooth' }), 100); }}
            className="text-left px-4 py-3 text-sm font-semibold text-foreground-700 rounded-lg hover:bg-background-100 transition-colors flex items-center gap-2"
          >
            <i className="ri-grid-line text-primary-500"></i>
            Categorias
          </button>
          <div className="border-t border-background-200 my-2"></div>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            onClick={() => setMobileOpen(false)}
            className="flex items-center justify-center gap-2 px-4 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold whitespace-nowrap"
          >
            CSSBuy Sheet <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>
      )}
    </nav>
  );
}